import base from './base2.repository';

export default {
    loadCargoVehicleEntries: (filters, page) => base.get(`cargo-vehicle-entries`, {...filters, page}),
    loadCompleteCargoVehicleEntries: (filters, page) => base.get(`cargo-vehicle-entries/complete`, {...filters, page}),
    loadCargoVehicleVendors: filters => base.get(`cargo-vehicle-entries/vendors`, filters),
    loadCargoVehicleDrivers: filters => base.get(`cargo-vehicle-entries/drivers`, filters),
    loadCargoVehicleEntriesAuthors: () => base.get(`cargo-vehicle-entries/authors`),
    saveCargoVehicleEntry: cargoVehicleEntries => base.post(`cargo-vehicle-entries`, cargoVehicleEntries),
    registerDeparture: (payload, id) => base.post(`cargo-vehicle-entries/departure/${id}`, payload),
    deleteCargoVehicleEntry: id => base.delete(`cargo-vehicle-entries/${id}`),
    saveCargoVehicleEntryPhotos: photos => base.post(`cargo-vehicle-entries/save-photos`, photos),
}